import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Info = styled.span`
  color: #00b300;
`;

export const Warning = styled.span`
  color: #c30;
`;

const formatGuideline = (destinationHeight, width) => {
  if (destinationHeight > 1400) {
    return (
      <Warning>
        This selection is too narrow!
        The image will extend beyond
        the edge of many screens.
      </Warning>
    );
  }

  if (destinationHeight < 240) {
    return (
      <Warning>
        This selection is too short!
      </Warning>
    );
  }

  return destinationHeight > width
    ? <Info>Portrait</Info>
    : <Info>Landscape</Info>;
};

const CropGuidelines = ({
  crop, width, height, uiScaling, dimensionsFixed,
}) => {
  const sourceWidth = Math.ceil(uiScaling * crop.width);
  const sourceHeight = Math.ceil(uiScaling * crop.height);
  const destinationHeight = Math.round((uiScaling * (width / crop.width))
    * crop.height);

  useEffect(
    () => {
      document.querySelector('body').style.overflow = 'hidden';
      return () => { document.querySelector('body').style.overflow = 'auto'; };
    },
    [],
  );

  return (
    <ul>
      <li>
        {
            dimensionsFixed
              ? `Width: ${sourceWidth} px ➔ ${width} px`
              : `Width: ${sourceWidth} px`
          }
      </li>
      <li>
        {
            dimensionsFixed
              ? `Height: ${sourceHeight} px ➔ ${height} px`
              : `Height: ${sourceHeight} px`
          }
      </li>
      {width && (
      <li>
        Quality:
        {' '}
        {
              sourceWidth < width
                ? (
                  <Warning>
                    This selection has low resolution!
                    The image will be upscaled,
                    which results in bad quality.
                  </Warning>
                )
                : (
                  <Info>
                    The selection has sufficient resolution.
                    The image will not be upscaled.
                    The quality is good enough for any screen.
                  </Info>
                )
            }
      </li>
      )}
      {!dimensionsFixed && width && (
      <li>
        Format:
        {' '}
        {
              formatGuideline(destinationHeight, width)
            }
      </li>
      )}
    </ul>
  );
};
CropGuidelines.propTypes = {
  crop: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  uiScaling: PropTypes.number,
  dimensionsFixed: PropTypes.bool,
};

CropGuidelines.defaultProps = {
  width: undefined,
  height: undefined,
  uiScaling: 1,
  dimensionsFixed: false,
};

export default CropGuidelines;
